"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variable = void 0;
var Variable;
(function (Variable) {
    Variable["Width"] = "%WIDTH%";
    Variable["Height"] = "%HEIGHT%";
    Variable["Top"] = "%TOP%";
    Variable["Bottom"] = "%BOTTOM%";
    Variable["Left"] = "%LEFT%";
    Variable["Right"] = "%RIGHT%";
})(Variable = exports.Variable || (exports.Variable = {}));
